// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  cloudCoverForecastDays: Number(process.env['APP_EE_CLOUD_COVER_FORECAST_DAYS'] ?? 30),
  production: true,
  gst: 9,
  payCurrency: "USD",
  payCurrencySign: "US$ ",
  eeDownloadUrl: process.env['APP_EE_DOWNLOAD_URL'] ?? "https://demo-tasking.eartheye.space/api/task/",
  eeTaskServer: process.env['APP_EE_TASK_URL'] ?? "https://demo-tasking.eartheye.space/api/task",
  usersServer: process.env['APP_EE_USER_URL'] ?? "https://demo-tasking.eartheye.space/api/user",
  mailServer: process.env['APP_EE_MAIL_URL'] ?? "https://demo-tasking.eartheye.space/api/email",
  demoView: process.env['APP_EE_DEMO_VIEW'] ?? "false",
  openCageApiKey: process.env['APP_EE_OPENCAGE_APIKEY'] ?? '',
  eeAssetsUrl: process.env['APP_EE_ASSETS_URL'] ?? "https://ee-website-assets.s3.amazonaws.com/develop/",
   recaptcha: {
    siteKey: '6Ld1FIwsAAAAAPLqSLOyS6XD5Edwn72wIyTjOwht',
  },
  minAllocationAmt: 150,
  postHogKey: process.env['APP_EE_POSTHOG_KEY'] ?? '',
  chatbotServer: process.env['APP_EE_CHATBOT_URL'] ?? "https://dup4c4xb4b9ht.cloudfront.net",
  isCopernicusLoad: process.env['APP_EE_COPERNICUS_LOAD'] ?? "false",
  geoServerUrl: process.env['APP_EE_GEO_SERVER_URL'] ?? "https://geo-pub-preprod.prodapps.eartheye.space/wms",
  enableSentinelBaseMap: "false",
  // --- STAC Browser embed (see plans/stac-frontend.md F3/F6) ---
  // Deliberately NOT read from process.env: webpack's EnvironmentPlugin allow-list in
  // extra-webpack-config.js does not declare any APP_EE_STAC_* key, and an undeclared
  // process.env[...] survives into the bundle and throws "process is not defined" at
  // runtime with no build error. To make these per-deployment configurable, add matching
  // APP_EE_STAC_* entries to that list (and to the export blocks in bitbucket-pipelines.yml)
  // in the same change that switches these to process.env.
  // Dark-launched OFF: flip to "true" (and rebuild) to expose the nav entry.
  stacUiEnabled: "true",
  // Same-origin paths, identical in every environment per F6 — nothing to templatise.
  // Trailing slash required (iframe src is `${stacUiUrl}#?~ee_stac_token=<token>`).
  stacUiUrl: "/stac/",
  // No trailing slash (requests are `${stacApiUrl}/token`).
  stacApiUrl: "/api/stac",
};
